import {ModalSlideRightEnterTransition} from "./slide/slide-right-enter.transition";
import {ModalSlideLeftLeaveTransition} from "./slide/slide-left-leave.transition";
import { ModalScaleUpEnterTransition } from "./scale/scale-up-enter.transition";
import { ModalScaleUpLeaveTransition} from "./scale/scale-up-leave.transition";
import { ModalSlidTopEnterTransition } from './slide/slide-top-enter.transition';
import { ModalSlideTopLeaveTransition} from './slide/slide-top-leave.transition';

export{
  ModalSlideRightEnterTransition,
  ModalSlideLeftLeaveTransition,
  ModalScaleUpEnterTransition,
  ModalScaleUpLeaveTransition,
  ModalSlidTopEnterTransition,
  ModalSlideTopLeaveTransition
}



// WEBPACK FOOTER //
// ./src/transitions/transitions.ts